import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { randuBlogService, categoriesService } from "../services/api";
import OrgCategoryMultiSelect from "../components/OrgCategoryMultiSelect";

const BlogRanduJobsPage = () => {
  const [items, setItems] = useState([]);
  const [keywords, setKeywords] = useState("");
  const [per, setPer] = useState(2);
  const [orgCatOptions, setOrgCatOptions] = useState([]);
  const [organization_category_ids, setOrganizationCategoryIds] = useState([]);

  const load = async () => {
    const res = await randuBlogService.listJobs();
    if (res.success) setItems(res.items || []);
  };

  useEffect(() => {
    load();
  }, []);

  useEffect(() => {
    (async () => {
      const res = await categoriesService.getAllFlat();
      if (res.success && Array.isArray(res.data)) setOrgCatOptions(res.data);
    })();
  }, []);

  const enqueue = async () => {
    const res = await randuBlogService.createJob({
      keywords_text: keywords,
      posts_per_keyword: per,
      organization_category_ids,
    });
    if (res.success) {
      setKeywords("");
      load();
      alert(`Kuyruğa eklendi. İş #${res.id}`);
    } else alert(res.message || "Hata");
  };

  return (
    <MasterLayout>
      <Breadcrumb title="Randu.app Blog — Kuyruk" />
      <div className="card mb-3">
        <div className="card-body">
          <OrgCategoryMultiSelect
            label="Üretilen yazılara eklenecek işletme kategorileri (isteğe bağlı)"
            options={orgCatOptions}
            value={organization_category_ids}
            onChange={setOrganizationCategoryIds}
          />
          <label className="form-label">Anahtar kelimeler (her satır bir kelime / konu)</label>
          <textarea className="form-control mb-2" rows={6} value={keywords} onChange={(e) => setKeywords(e.target.value)} />
          <div className="row g-2 align-items-center">
            <div className="col-auto">
              <label className="form-label mb-0">Kelime başına yazı</label>
            </div>
            <div className="col-auto">
              <input
                type="number"
                min={1}
                max={5}
                className="form-control"
                style={{ width: 80 }}
                value={per}
                onChange={(e) => setPer(parseInt(e.target.value, 10) || 2)}
              />
            </div>
            <div className="col-auto">
              <button type="button" className="btn btn-primary" onClick={enqueue}>
                Kuyruğa ekle
              </button>
            </div>
          </div>
          <p className="small text-muted mt-2 mb-0">
            Arka planda <code>pm2</code> ile <code>zpanel-blog-worker</code> çalışıyor olmalı. Sunucuda:{" "}
            <code>npm run blog-worker</code> veya ecosystem içindeki worker.
          </p>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <table className="table table-sm">
            <thead>
              <tr>
                <th>ID</th>
                <th>Durum</th>
                <th>Satır başına</th>
                <th>İşletme kat.</th>
                <th>Hata</th>
                <th>Log</th>
              </tr>
            </thead>
            <tbody>
              {items.map((j) => (
                <tr key={j.id}>
                  <td>{j.id}</td>
                  <td>{j.status}</td>
                  <td>{j.posts_per_keyword}</td>
                  <td className="small">
                    {j.organization_category_ids
                      ? typeof j.organization_category_ids === "string"
                        ? j.organization_category_ids
                        : JSON.stringify(j.organization_category_ids)
                      : "—"}
                  </td>
                  <td className="text-truncate" style={{ maxWidth: 200 }}>
                    {j.error_message || "—"}
                  </td>
                  <td>
                    <Link to={`/blog-randu/jobs/${j.id}/logs`}>Loglar</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </MasterLayout>
  );
};

export default BlogRanduJobsPage;
